// extracted by mini-css-extract-plugin
export var activityContainer = "_md-0";
export var typingIndicatorContainer = "_md-1";
export var typingIndicatorDot = "_md-2";
export var wave = "_md-3";